import { render, staticRenderFns } from "./ListV2.vue?vue&type=template&id=5d1b8914"
import script from "./ListV2.vue?vue&type=script&lang=ts"
export * from "./ListV2.vue?vue&type=script&lang=ts"
import style0 from "./ListV2.vue?vue&type=style&index=0&id=5d1b8914&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports